export default __webpack_public_path__ + "static/media/temp 1.ad3e6362.svg";